import api from '@/api';

export default {
  track: (recaptcha, codigoRastreio) => api.post('track', {
    trackingCode: codigoRastreio,
    recaptcha,
  }),
};
